import { getSubmitPayment } from "./logic/logic";
import { regularPaymentMap, resendMap } from "./map.dev";
import { sendCardPayment as sendCardPaymentResend } from "./methods/card/index.resend";
import { sendCardPayment as sendNewCardPaymentResend } from "./methods/card/index.regular.resend";
import { sendSbpPayment as sendSbpPaymentResend } from "./methods/fps/index.resend";
import { sendSberpayPayment as sendSberpayPaymentResend } from "./methods/sberpay/index.resend";
resendMap.sberpay = sendSberpayPaymentResend;
resendMap.fps = sendSbpPaymentResend;
resendMap.savedCards = sendCardPaymentResend;
resendMap.card = sendNewCardPaymentResend;
export var submitPayment = getSubmitPayment({
  regularPaymentMap: regularPaymentMap,
  quickPaymentMap: resendMap
});